import client from './client';
import type { VoiceProvider } from '../types';

export interface VoiceProviderRequest {
  name: string;
  provider_type: 'twilio' | 'plivo' | 'custom';
  account_sid?: string;
  auth_token?: string;
  api_key?: string;
  api_secret?: string;
  from_number: string;
  script_template: string;
  extra_config?: string;
}

export const voiceProvidersApi = {
  getAll: () => client.get<VoiceProvider[]>('/voice-providers/'),
  getById: (id: number) => client.get<VoiceProvider>(`/voice-providers/${id}`),
  create: (data: VoiceProviderRequest) => client.post<VoiceProvider>('/voice-providers/', data),
  update: (id: number, data: VoiceProviderRequest) => client.put<VoiceProvider>(`/voice-providers/${id}`, { ...data, id }),
  delete: (id: number) => client.delete<{ success: boolean; message: string }>(`/voice-providers/${id}`),
};
